import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import banner from '../../assets/prkbanner.jpg'
import "./Home.css"
import WhyJoinUs from "../../Pages/WhyJoinUs";
import Testimonial from "../../Pages/Testimonial/Testimonial";
import VisionMission from "../../Pages/VisionMission/VisionMission";
import CoreValues from "../../Pages/CoreValues/CoreValues";
import Courses from "../../Pages/Courses/Courses";


const Home = () => {
  return (
    <div className="hero-section container-fluid p-5 home text-light text-center">
      <div className="row  mt-5">
        <div className="col-md-6 col-12">
          <h1 className="fw-bold" style={{ fontFamily: "Dancing Script, cursive" }}>
            Your Gateway to Success
          </h1>
          <p className="lead">
            Empowering students to excel in IIT-JEE, NEET, and State Board Exams
          </p>
          <button className="btn btn-danger btn-lg">Get Free Counseling</button>
        </div>
        <div className="col-md-6 col-12  mt-3">
          <img
            src={banner}
            alt="Institute"
            className="img-fluid"
          />
        </div>
      </div>

      <WhyJoinUs/>
      <VisionMission/>
      <CoreValues/>
      <Courses/>
      <Testimonial/>
    
    </div>
  );
};

export default Home;
